import React from "react";
import DataGrid from "./DataGrid.jsx";

export const PagedDataGrid = ({ ref, data, children, onPageInfoChange, ...gridProps }) => {

    const handleGridStateChanged = async (gridState) => {
        // Map to whatever our server API makes use of for pagination.
        const mappedGridState = {
            pageIndex: gridState?.skip ? (gridState.skip / gridState.take) : 0,
            pageSize: gridState?.take ?? 20,
            sort: gridState.sort,
            filter: gridState.filter,
            group: gridState.group,
        };

        await onPageInfoChange(mappedGridState);
    };

    return (
        <DataGrid
            ref={ref}
            data={data?.items}
            onChange={handleGridStateChanged}
            total={data?.totalItemCount ?? 0}
            {...gridProps}
        >
            {children}
        </DataGrid>
    );
};